const Logo_data = [
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-1.png",
    },
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-2.png",
    },
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-3.png",
    },
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-4.png",
    },
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-5.png",
    },
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-2.png",
    },
    {
      cover: "https://tranquil-licorice-79e76f.netlify.app/images/gallery/gallery-4.png",
    },
  ]
  
  export default Logo_data;